import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import { clearSearch } from '../../../actions/executeActions';
import StringUtil from '../../../common/StringUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExecuteSider from '../ExecuteSider';
import TemplateTable from './TemplateTable';
import SiteSearchInput from "../SiteAutoSearch";
import TemplateSearch from './TemplateSearch'; 
import '../style/list.less';

class Template extends Component {
    state = {
        data: [],
        type: 'patient',
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        searchArray: [],
        tableColumns: [],
        tableDatas: [],
        searchParams: {},
    }

    componentDidMount() {
        this.changeProps(this.props);
        this.queryInvestigationStageByInvId();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params != this.props.params) {
            this.changeProps(nextProps)
        }
    }

    changeProps = (props) => {
        const { params } = props;
        if (Object.keys(params).length > 0) {
            const { patientTypeId, noPatientTypeId, patientTypeName, noPatientTypeName } = params;
            const type = patientTypeName ? 'patient' : 'noPatient';
            const typeName = patientTypeName || noPatientTypeName;
            const followBoardTypeId = patientTypeId || noPatientTypeId;
    
            this.setState({
                type,
                typeName,
                followBoardTypeId,
            }, () => {
                this.loadHead();
            });
        }
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    loadHead = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.queryVisitGrouping,
            data: {},
            dataType: 'json',
            doneResult: res => {
                if(res && res.data.length <=0)
                {
                    return
                }
                const visitGroupingId = res.data[0].visitGroupingId + '';
                this.setState({
                    loading: false,
                    visitGroupingId,
                }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    loadData = (isAdd) => {
        let { typeName, followBoardTypeId, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const newParams = this.getLoadDataParam();
        this.setState({ loading: true });

        const options = {
            method: 'post',
            url: `${API_URL.execute.list}?${newParams}`,
            data: {
                typeName,
                followBoardTypeId,
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: (res => {
                const { pagination } = this.state;
                const { tableColumns = [], searchArray = [], codeList = [] } = res.data.tree.data;
                pagination.total = res.data.totalCount;

                this.setState({
                    searchArray,
                    tableColumns,
                    tableDatas: res.data.datas,
                    loading: false,
                    pagination,
                    codeList,
                }, () => {
                    if (isAdd == "add") {
                        this.handleAdd();
                    }
                });
            })
        };
        $.sendRequest(options);
    }

    getLoadDataParam = () => {
        let key,
            type,
            WebType,
            path,
            searchValue,
            newParam = '';
        const { searchParams } = this.props;
        const { searchParams: ssearchParams } = this.state;
        const { investigationSiteId } = ssearchParams;
        for (key in searchParams) {
            path = `&conditions[${key}].listConditions[0]`;
            type = searchParams[key].criteriaDataType;
            WebType = searchParams[key].projectDefineWebType;
            searchValue = searchParams[key].searchValue;
            if (searchValue) {
                if (type == 'TEXT') {
                    if (WebType === 'CASCADE_SELECT') {
                        newParam += `${path}.conditions[0].oper=EQ`;
                        newParam += `${path}.conditions[0].value=${searchValue}`;
                    } else {
                        newParam += `${path}.conditions[0].oper=LIKE`;
                        newParam += `${path}.conditions[0].value=${searchValue}`;
                    }
                } else if (type == 'NUMBER' || type == 'PatientCodeSearchSelect') {
                    newParam += `${path}.conditions[0].oper=LIKE`;
                    newParam += `${path}.conditions[0].value=${searchValue}`;
                } else if (type == 'DATE') {
                    newParam += `${path}.conditions[0].oper=GE`;
                    newParam += `${path}.conditions[0].value=${searchValue[0]}`;
                    newParam += `${path}.oper=AND`;
                    newParam += `${path}.conditions[1].oper=LE`;
                    newParam += `${path}.conditions[1].value=${searchValue[1]}`;
                }
            }
        }
        if (investigationSiteId) {
            newParam += `&siteId=${investigationSiteId}`;
		}
        return newParam;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }
    
    reset = () => {
        this.props.clearSearchParams();
        this.setState({
            renderSite: false,
            renderSearch: false,
            searchParams: {},
        }, () => {
            this.setState({
                renderSite: true,
                renderSearch: true,
            }, () => {
                this.loadData();
            });
        });
    }

    export = () => {
        const { typeName, searchParams } = this.state;
        const { invId, siteId, userId, curRole, curEnterpriseId, curEmployeeCode } = sessionStorage;
        const { investigationSiteId } = searchParams;
        const newParams = this.getLoadDataParam();
        let locationRef = `${API_URL.export.exportTypeVisit}?${newParams}`;
        if(investigationSiteId){
            locationRef += "&siteId=" + investigationSiteId;
        }
        if (curEnterpriseId > 0){
            locationRef += '&curEnterpriseId=' + curEnterpriseId;
        }
        if (userId > 0){
            locationRef += '&curUserId=' + userId;
        }
        if (invId > 0){
            locationRef += '&curInvId=' + invId;
        }
        if (siteId > 0){
            locationRef += '&curSiteId=' + siteId;
        }
        if (!StringUtil.isNull(curRole)){
            locationRef += '&curRoleCode=' + encodeURIComponent(curRole);
        }
        if (!StringUtil.isNull(curEmployeeCode)){
            locationRef += '&curEmployeeCode=' + encodeURIComponent(curEmployeeCode);
        }
        locationRef += '&typeName=' + typeName;
        window.location.href = locationRef;
    }

    handleSelectSite = ({ value, text }) => {
        const { searchParams } = this.state;
        searchParams.investigationSiteId = value;
        searchParams.investigationSiteCode = text;
        this.setState({ searchParams });
    }

    handleSiteChange = value => {
        if (value) {
            if (value.key == "") {
                const { searchParams } = this.state;
                searchParams.investigationSiteId = undefined;
                this.setState({ searchParams });
            }
        }
    }

    handleAdd = () => {
        const { pagination } = this.state;
        const { current } = pagination;
        if (current == 1) {
            this.TemplateTableRef.handleAdd();
        } else {
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData("add");
            });
        }
    }

    handleBtnClick = (type) => {
        const { params } = this.props;
        const { patientTypeId, noPatientTypeId, patientTypeName, noPatientTypeName } = params;

        let typeName, followBoardTypeId;
        if (type == 'patient') {
            typeName = patientTypeName;
            followBoardTypeId = patientTypeId;
        } else {
            typeName = noPatientTypeName;
            followBoardTypeId = noPatientTypeId;
        }
        this.setState({
            type,
            typeName,
            followBoardTypeId,
            renderSite: false,
            renderSearch: false,
            searchParams: {},
        }, () => {
            this.setState({
                renderSite: true,
                renderSearch: true,
            }, () => {
                this.loadData();
            });
        });
    }

    render() {
        const {
            type,
            pagination,
            loading,
            tableDatas,
            searchArray,
            codeList = [],
            typeName = '',
            tableColumns = [],
            renderSearch = true,
            renderSite = true,
            visitGroupingId,
        } = this.state;
        const { params } = this.props;
        const { isRelatedPatient, patientTypeName, noPatientTypeName, followBoardName } = params;
        const { siteId, curRole } = sessionStorage;
        return (
            <div className="content">
                <ExecuteSider selectKey={patientTypeName || noPatientTypeName} />
                <div className="main execute-crf">
                    {
                        isRelatedPatient == "BOTH" &&
                        <div className="tab_flex" style={{margin: '20px 0'}}>
                            <a className={type == "patient" ? "curr" : ""} onClick={() => this.handleBtnClick('patient')} >{`与患者有关的${followBoardName}`}</a>
                            <a className={type == "noPatient" ? "curr" : ""} onClick={() => this.handleBtnClick('noPatient')} >{`与患者无关的${followBoardName}`}</a>
                        </div>
                    }
                    <div className="filter-bar work-data-bar">
                        {
                            renderSearch && 
                            searchArray.map(item => <TemplateSearch key={item.moduleDefineId} searchItem={item} />)
                        }
                        {
                            siteId == 0 && renderSite &&
                            <div className="form-item autoInput">
                                <label htmlFor="" className="ui-label">中心名称\中心编号</label>
                                <SiteSearchInput
                                    selectKey={typeName}
                                    style={{width: 200}}
                                    handleSelectSite = {this.handleSelectSite}
                                    handleSiteChange = {this.handleSiteChange}
                                    ref={el => this.siteSearchInput = el}
                                />
                            </div>
                        }
                        <div className="form-item">
                            {
                                curRole == 'CRC' && <Button type="primary" onClick={() => this.canEditByInvStatus(this.handleAdd)}>添加</Button>
                            }
                            <Button type="primary" onClick={this.export}>导出</Button>
                            <Button type="primary" onClick={this.reset}>重置</Button>
                            <Button type="primary" onClick={this.search}>搜索</Button>
                        </div>
                    </div>
                    <div className="main-content">
                        <TemplateTable
                            codeList={codeList}
                            tableColumns={tableColumns}
                            tableDatas={tableDatas}
                            typeName={typeName}
                            ref={el => this.TemplateTableRef = el}
                            loading={loading}
                            loadData={this.loadData}
                            pagination={pagination}
                            visitGroupingId={visitGroupingId}
                            canEditByInvStatus={this.canEditByInvStatus}
                            handleTableChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.templateState.selectItem || {},
        searchParams: state.executeState.searchParams || {},
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearSearchParams: () => dispatch(clearSearch()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Template);


// WEBPACK FOOTER //
// ./src/components/execute/template/index.js